import datasheet from "./datasheet";
import { Content } from "iview";
import { encodePrefix, getSdkSaveData } from "@/public/utils/tool";

import { Vue } from "@/public/utils/customVue";

let $edApi = Vue.prototype.$edApi;

declare var EDView: any;
declare var AutoSaveTimer;
import * as Sentry from "@sentry/vue";

export default {
    state: {
        notCloudFile: false, // 是否是当前账户的云文件
        userInfo: {
            user_id: 0,
            user_name: "",
            nick_name: "",
            token: "",
            lang: "",
            islogin: false,
        },
        starter: null,
        userConfig: {
            presetPaper: 13,
            presetUnit: 0,
            pageMarginX: 10,
            pageMarginY: 10,
            dateFormat: "MM/dd/yyyy",
            currencyUnit: "USD",
        },
        domain: "",
        isAd: false,
        // for sensors track
        file_source: "",
        template_type: "",
        is_export_file: "notExportFile",
        diagram_type: "",
        lv2_type: "",
        last_template_name: "",
        fromNull: false,
        graphkd: 1,
        isAIOpened: true,
        noLoginEditor: false,
        seo_source: "",
    },
    getters: {
        userConfig: (state) => {
            return state.userConfig; // for debug
        },
        userName: (state) => {
            return state.userInfo.nick_name;
        },
        domain: (state) => {
            return state.domain;
        },
        apiParam: (state) => {
            let params = {};
            //     fileKey = state.fileKey,
            //     targetFileKey = state.targetFileKey;
            //文件信息
            // params.curFileKey = fileKey;
            // params.curFilePath = fileKey.substring(
            //     fileKey.indexOf("Personal") + 9,
            //     fileKey.length
            // );
            // params.curFileName =
            //     fileKey && fileKey.match(/\/([^%#?&/]+)\.emmx$/)[1];

            // params.targetFileKey = targetFileKey;
            // params.targetFilePath = targetFileKey.substring(
            //     targetFileKey.indexOf("Personal") + 9,
            //     targetFileKey.length
            // );
            // params.targetFileName =
            //     targetFileKey && targetFileKey.match(/\/([^%#?&/]+)\.emmx$/)[1];
            // //个人信息
            let { user_id: id, user_name: userName, nick_name: nickName, token, lang, islogin } = state.userInfo;
            params = Object.assign(params, {
                id,
                token,
                userName,
                nickName,
                lang,
                islogin,
            });
            //语言和地区
            return params;
        },
        isActivityUser: (state) => {
            return state.graphkd === 2;
        },
    },
    mutations: {
        setDomain(state, payload) {
            state.domain = payload;
        },
        setState(state, obj) {
            state[obj.type] = obj.data;
        },
        logout(state, obj) {
            if (state.userInfo.qq || state.userInfo.weixin) {
                document.cookie = "EDUid=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
                document.cookie = "EDUid=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=" + state.domain;
            }
            state.userInfo = "";
            document.cookie = "EDCurrent=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "EDCurrent=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=" + state.domain;
            document.cookie = "EDSession=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/";
            document.cookie = "EDSession=; expires=Thu, 01 Jan 1970 00:00:01 GMT; path=/; domain=" + state.domain;
        },
    },
    actions: {
        getUserInfo({ rootGetters, state }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .getUserInfo(rootGetters.apiParam)
                    .then((res) => {
                        resolve(res);
                        res.data.token = state.userInfo.token;
                        state.userInfo = res.data;
                        state.userInfo.islogin = true;
                        if (res.data && res.data.user_id) {
                            Sentry.setUser({ id: res.data.user_id });
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadFiles({ rootGetters, state }, obj) {
            if (this._vm.isPrivate) {
                let fileKey = obj.match(/[^\/]*$/)[0];
                return new Promise((resolve, reject) => {
                    let params = Object.assign({ file_key: fileKey }, rootGetters.apiParam);
                    $edApi.privateGetDownFileAddress(params).then((res) => {
                        let ossParams = { url: obj, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "blob" };
                        $edApi
                            .downloadOSSFile(ossParams)
                            .then((res) => {
                                resolve(res);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    });
                });
            }
            let filePath = obj.match(/[^\/]+\/[^\/]+\/(.+)/) && obj.match(/[^\/]+\/[^\/]+\/(.+)/)[1];
            return new Promise((resolve, reject) => {
                let params = Object.assign({ obj: filePath }, rootGetters.apiParam);
                $edApi
                    .getDownFileAddress(params)
                    .then((res) => {
                        let ossParams = { url: obj, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "blob" };
                        $edApi
                            .downloadOSSFile(ossParams)
                            .then((res) => {
                                resolve(res);
                            })
                            .catch((err) => {
                                reject(err);
                            });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadShareFiles({ rootGetters, state, rootState }, param) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                let params = Object.assign(param, rootGetters.apiParam);
                params = Object.assign(params, { platform: runplatform });
                $edApi
                    .getShareDownFileAddress(params)
                    .then((res) => {
                        if (res.msg === "Not allowed") {
                            reject("Not allowed");
                        } else {
                            let ossParams = {};
                            if (this._vm.isPrivate) {
                                ossParams = { url: res.data.path, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "blob" };
                            } else {
                                ossParams = { url: param.obj, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "blob" };
                            }
                            $edApi
                                .downloadOSSFile(ossParams)
                                .then((res) => {
                                    resolve(res);
                                })
                                .catch((err) => {
                                    reject(err);
                                });
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadTeamFiles({ rootGetters, state }, param) {
            return new Promise((resolve, reject) => {
                let params = Object.assign(param, rootGetters.apiParam);
                $edApi
                    .getTeamDownFileAddress(params)
                    .then((res) => {
                        if (res.msg === "Not allowed") {
                            reject("Not allowed");
                        } else {
                            let ossParams = {};
                            if (this._vm.isPrivate) {
                                ossParams = { url: res.data.path, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "blob" };
                            } else {
                                ossParams = { url: param.obj, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "blob" };
                            }
                            $edApi
                                .downloadOSSFile(ossParams)
                                .then((res) => {
                                    resolve(res);
                                })
                                .catch((err) => {
                                    if (param.obj !== res.data.path) {
                                        reject({ msg: "renamed" });
                                    }
                                    reject(err);
                                });
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        // downloadTem ({state}, obj) {
        //     return new Promise((resolve, reject) => {
        //         axios.get(obj, {responseType: "blob"})
        //         .then(res => {
        //             resolve(res)
        //         })
        //         .catch(err => {
        //             reject(err)
        //         })
        //     })
        // },
        uploadCustomTheme({ rootGetters, state }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .uploadCustomTheme(rootGetters.apiParam)
                    .then((res) => {
                        let ossParams = {
                            url: res.data.obj,
                            exp: res.data.exp,
                            sign: res.data.sign,
                            file: obj.file,
                            contentType: "application/octet-stream",
                        };
                        $edApi.uploadOSSFile(ossParams).then((res) => {
                            resolve({ res });
                        });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        downloadCustomTheme({ rootGetters, state }, obj) {
            return new Promise((resolve, reject) => {
                $edApi
                    .downloadCustomTheme(rootGetters.apiParam)
                    .then((res) => {
                        if (res.data) {
                            let ossParams = { url: res.data.obj, exp: res.data.exp, sign: res.data.sign || res.data.query, responseType: "text" };
                            $edApi
                                .downloadOSSFile(ossParams)
                                .then((res) => {
                                    resolve(res);
                                })
                                .catch((err) => {
                                    resolve();
                                });
                        } else resolve(res);
                    })
                    .catch((err) => {
                        resolve();
                    });
            });
        },
        getFloder({ rootGetters, state }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ prefix: encodePrefix(obj.prefix) }, rootGetters.apiParam);
                $edApi
                    .getFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        createFolder({ state, getters }, obj) {
            return new Promise((resolve, reject) => {
                let params = Object.assign({ prefix: obj.prefix }, getters.apiParam);
                $edApi
                    .createFolder(params)
                    .then((res) => {
                        resolve(res);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        saveFile({ rootGetters, state, commit, rootState }, obj) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                let params = Object.assign({ obj: obj.name, size: obj.size, platform: runplatform }, rootGetters.apiParam);
                if (this._vm.isPrivate) {
                    Object.assign(params, {
                        folder_id: obj.folderId,
                        name: obj.fileName,
                    });
                    if (obj.pushHis) {
                        Object.assign(params, {
                            file_key: obj.file_key,
                        });
                    }
                }
                $edApi
                    .getCloudFileSign(params)
                    .then((res) => {
                        if (res.msg == "file num over limit") {
                            commit("toPublicStatus", {
                                type: "showUpgrade",
                                data: "fileNum",
                            });
                            reject();
                        } else if (res.msg == "storage space not enough") {
                            reject("storageLimit");
                        } else if (res.data) {
                            // 上传文件
                            let ossParams = {
                                url: encodePrefix(res.data.obj),
                                exp: res.data.exp,
                                sign: res.data.sign,
                                file: obj.file,
                                contentType: "application/octet-stream",
                            };
                            $edApi.uploadOSSFile(ossParams).then((re) => {
                                resolve({ res, path: `${state.userInfo.user_name}/Personal/${obj.file.name}` });
                            });
                            // 上传封面图片
                            let imageOssParams = {
                                url: encodePrefix(res.data.img),
                                exp: res.data.exp,
                                sign: res.data.img_up_sign,
                                file: obj.img,
                                contentType: "image/png",
                            };
                            $edApi.uploadOSSFile(imageOssParams).then((re) => {});
                        }
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        saveVersion({ rootGetters, state, commit, rootState }, payload) {
            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                if (!state.userInfo) {
                    console.log("自动保存历史版本失败，未登录");
                    reject("notLogin");
                    return;
                }
                commit("setState", {
                    type: "notCloudFile",
                    data: false,
                });
                let result = payload.urlSearch;
                let shareUUID = rootGetters.shareUUID;
                let editTeam = rootGetters.editTeamOption;
                if (shareUUID || editTeam) {
                    reject();
                    return;
                }
                if (this._vm.isPrivate || window.EDCONFIG.IS_SDK) {
                } else if (result) {
                    let obj = result;
                    let re = new RegExp("^" + state.userInfo.user_name, "i");
                    let res = obj.match(re);
                    if (!res) {
                        console.log("自动保存历史版本失败，不是个人云文件");
                        commit("setState", {
                            type: "notCloudFile",
                            data: true,
                        });
                        reject("notCloudFile");
                        return;
                    }
                } else {
                    console.log("自动保存历史版本失败，不是个人云文件");
                    reject("notCloudFile");
                    return;
                }

                window["_view"]
                    .zipFile()
                    .then((content) => {
                        EDView.s_isSaving = false;
                        let canvas = window["_view"].saveTemplateThumbnailToCover();
                        canvas.toBlob((blob) => {
                            let name = payload.urlSearch;
                            if (!window.EDCONFIG.IS_SDK && !name.endsWith(".eddx")) {
                                name += ".eddx";
                            }
                            let obj = {
                                name: name,
                                size: content[0].size,
                                file: content[0],
                                img: blob,
                            };

                            let params = {
                                obj: name,
                                platform: runplatform,
                                description: payload.versionDes,
                                user_id: state.userInfo.user_id,
                                token: state.userInfo.token,
                                name: payload.name,
                                auto: payload.auto,
                            };
                            if (this._vm.isPrivate) {
                                Object.assign(params, {
                                    file_key: payload.file_key,
                                    size: content[0].size,
                                });
                            }

                            if (window.EDCONFIG.IS_SDK) {
                                this._vm.sdkApp
                                    .promisePostMessage("POST_VERSION", { ...obj, title: payload.name, auto: payload.auto })
                                    .then(() => {
                                        this.dispatch("getVersionList", { obj: obj.name })
                                            .then((data) => {
                                                resolve(data);
                                            })
                                            .catch(() => reject());
                                    })
                                    .catch(() => reject());
                                return;
                            }

                            $edApi
                                .pushHisVersion2(params)
                                .then(async (res) => {
                                    // 上传文件
                                    let url = encodePrefix(res.data.obj);
                                    let sign = res.data.sign;
                                    let exp = res.data.exp;
                                    let ossParams = { url, exp, sign, file: obj.file, contentType: "application/octet-stream" };

                                    // 上传封面图片
                                    if (!res.data.img) {
                                        reject();
                                        return;
                                    }
                                    let img_sign = res.data.img_up_sign;
                                    let imageOssParams = { url: res.data.img, exp, sign: img_sign, file: obj.img, contentType: "image/png" };
                                    try {
                                        await Promise.all([$edApi.uploadOSSFile(ossParams), $edApi.uploadOSSFile(imageOssParams)]);
                                        await $edApi.pushHisVersionCallback({
                                            token: state.userInfo.token,
                                            code: res.data.code,
                                            user_id: state.userInfo.user_id,
                                            file_key: rootGetters.fileKey,
                                            ver_file_key: res.data.ver_file_key,
                                        });
                                        this.dispatch("getVersionList", { obj: obj.name })
                                            .then((data) => {
                                                resolve(data);
                                            })
                                            .catch(() => reject());
                                    } catch (error) {
                                        reject();
                                    }
                                })
                                .catch(() => reject());
                        }, "image/png");
                    })
                    .catch(() => reject());
            });
        },

        // 自动保存
        async autoSaveFile({ rootGetters, state, commit, rootState }, payload) {
            if (window.EDCONFIG.AUTO_SAVE_ENABLE === false) {
                if (AutoSaveTimer) {
                    clearTimeout(AutoSaveTimer);
                    AutoSaveTimer = null;
                }
                return;
            }

            if (window.EDCONFIG.IS_SDK) {
                const fileData = await getSdkSaveData();
                this._vm.sdkApp
                    .promisePostMessage("PUT_FILE", {
                        file: fileData.file,
                        img: fileData.img,
                        isAuto: true,
                        svgImg: fileData.svgImg,
                    })
                    .finally(() => {
                        if (AutoSaveTimer) {
                            clearTimeout(AutoSaveTimer);
                            AutoSaveTimer = null;
                        }
                    });
                return;
            }

            let runplatform = rootState["publicStore"].runPlatform;
            return new Promise((resolve, reject) => {
                if (!state.userInfo) {
                    console.log("自动保存失败，未登录");
                    reject("notLogin");
                    return;
                }
                commit("setState", {
                    type: "notCloudFile",
                    data: false,
                });
                let result = payload.urlSearch;
                let shareUUID = rootGetters.shareUUID;
                let editTeam = rootGetters.editTeamOption;
                let fileKey = rootGetters.fileKey;
                if (!shareUUID && !editTeam) {
                    if (this._vm.isPrivate) {
                    } else if (result) {
                        let obj = result;
                        let re = new RegExp("^" + state.userInfo.user_name, "i");
                        let res = obj.match(re);
                        if (!res) {
                            console.log("自动保存失败，不是个人云文件");
                            commit("setState", {
                                type: "notCloudFile",
                                data: true,
                            });
                            reject("notCloudFile");
                            return;
                        }
                    } else {
                        console.log("自动保存失败，不是个人云文件");
                        reject("notCloudFile");
                        return;
                    }
                }

                window["_view"]
                    .zipFile()
                    .then((content) => {
                        EDView.s_isSaving = false;
                        let name = payload.urlSearch;
                        if (!name.endsWith(".eddx")) {
                            name += ".eddx";
                        }
                        let obj = {
                            name: name,
                            size: content[0].size,
                            file: content[0],
                        };
                        let params = Object.assign({ obj: obj.name, size: obj.size, uuid: shareUUID, platform: runplatform }, rootGetters.apiParam);
                        const getCover = () => {
                            return new Promise((s, j) => {
                                let canvas = window["_view"].saveTemplateThumbnailToCover();
                                canvas.toBlob((blob) => {
                                    s(blob);
                                });
                            });
                        };
                        const getSign = () => {
                            return new Promise((s, j) => {
                                if (shareUUID) {
                                    if (rootGetters.shareEtag) {
                                        // 国内需检验etag
                                        let etagParam = Object.assign({ etag: rootGetters.shareEtag, uuid: shareUUID }, rootGetters.apiParam);
                                        $edApi.compareEtag(etagParam).then((res) => {
                                            if (res.msg === "etag not match" || res.msg === "not found") {
                                                reject(res.msg);
                                            } else {
                                                $edApi
                                                    .getShareFileSign(params)
                                                    .then((res) => {
                                                        s(res);
                                                    })
                                                    .catch((err) => {
                                                        reject(err);
                                                    });
                                            }
                                        });
                                    } else {
                                        $edApi
                                            .getShareFileSign(params)
                                            .then((res) => {
                                                s(res);
                                            })
                                            .catch((err) => {
                                                reject(err);
                                            });
                                    }
                                } else if (editTeam) {
                                    let teamParam = Object.assign({ teamId: editTeam[0], objId: editTeam[1] }, rootGetters.apiParam);
                                    if (this._vm.isPrivate) {
                                        Object.assign(teamParam, {
                                            file_key: fileKey,
                                        });
                                    }
                                    $edApi
                                        .getTeamFileSign(teamParam)
                                        .then((res) => {
                                            s(res);
                                        })
                                        .catch((err) => {
                                            reject(err);
                                        });
                                } else {
                                    let obj = { platform: runplatform };
                                    Object.assign(obj, params);
                                    $edApi
                                        .getCloudFileSign(obj)
                                        .then((res) => {
                                            s(res);
                                        })
                                        .catch((err) => {
                                            reject("getSignFail");
                                        });
                                }
                            });
                        };
                        const upload = (res) => {
                            if (res.msg == "file num over limit") {
                                commit("toPublicStatus", {
                                    type: "showUpgrade",
                                    data: "fileNum",
                                });
                                reject("fileNumLimit");
                            } else if (res.msg === "not found" || res.msg === "notLocked") {
                                reject(res.msg);
                            } else if (res.msg == "storage space not enough") {
                                reject("storageLimit");
                            } else if (res.msg === "read only") {
                                reject("fileReadOnly");
                            } else if (res.data) {
                                uploadEDDX(res);
                                if (!payload.onlyEddx) {
                                    uploadCover(res);
                                }
                            }
                        };
                        const uploadEDDX = (res) => {
                            let url = shareUUID ? obj.name : res.data.obj;
                            let sign = editTeam ? res.data.obj_up_sign : res.data.sign;
                            let exp = editTeam ? res.data.up_exp : res.data.exp;
                            if (this._vm.isPrivate && shareUUID) {
                                url = res.data.obj;
                            }

                            // url encode
                            let filePath = url.split("/");
                            let fileName = encodeURIComponent(filePath.pop());
                            url = filePath.join("/") + "/" + fileName;

                            let ossParams = { url, exp, sign, file: obj.file, contentType: "application/octet-stream" };
                            return $edApi
                                .uploadOSSFile(ossParams)
                                .then((res) => {
                                    if (shareUUID) {
                                        if (res.headers.etag) {
                                            commit("setStatus", {
                                                type: "shareEtag",
                                                data: res.headers.etag.slice(1, -1),
                                            });
                                        }
                                    }
                                    resolve({ res, path: obj.name });
                                })
                                .catch((e) => {
                                    reject("uploadFail");
                                });
                        };
                        const uploadCover = (res) => {
                            // 上传封面图片
                            if (!res.data.img) return;
                            const imgBlob = getCover();
                            let url = shareUUID ? obj.name : res.data.obj;
                            let sign = editTeam ? res.data.obj_up_sign : res.data.sign;
                            let exp = editTeam ? res.data.up_exp : res.data.exp;
                            if (this._vm.isPrivate && shareUUID) {
                                url = res.data.obj;
                            }
                            let img_sign = shareUUID ? res.data.img_sign : res.data.img_up_sign;
                            return getCover().then((img) => {
                                let imageOssParams = { url: res.data.img, exp, sign: img_sign, file: img, contentType: "image/png" };
                                $edApi.uploadOSSFile(imageOssParams).then((res) => {});
                                if (shareUUID || editTeam) {
                                    return;
                                }
                            });
                        };
                        getSign().then(upload);
                    })
                    .catch((e) => {
                        if (e == "pageError") {
                            reject("pageErrorFail");
                        } else {
                            reject("saving");
                        }
                    });
            });
        },
        // 获取偏好设置
        getUserPrefer({ state, commit }) {
            if (state.userInfo === "") return;
            return new Promise((resolve, reject) => {
                let userID = state.userInfo.user_id;
                if (userID) {
                    let params = { id: userID };
                    $edApi
                        .getUserPrefer(params)
                        .then((res) => {
                            if (res.status == "success") {
                                if (res.data.language) {
                                    commit("changeUILang", res.data.language);
                                }
                                if (res.data.sizeRadio != null) {
                                    commit("setStatus", {
                                        type: "sizeRadio",
                                        data: res.data.sizeRadio,
                                    });
                                }
                                if (res.data.shapeRadio != null) {
                                    commit("setStatus", {
                                        type: "shapeRadio",
                                        data: res.data.shapeRadio,
                                    });
                                }
                                if (res.data.typeRadio != null) {
                                    commit("setStatus", {
                                        type: "typeRadio",
                                        data: res.data.typeRadio,
                                    });
                                }
                                if (res.data.scaleNum != null) {
                                    commit("setStatus", {
                                        type: "scaleNum",
                                        data: res.data.scaleNum,
                                    });
                                }
                                if (res.data.widthNum != null) {
                                    commit("setStatus", {
                                        type: "widthNum",
                                        data: res.data.widthNum,
                                    });
                                }
                                if (res.data.heightNum != null) {
                                    commit("setStatus", {
                                        type: "heightNum",
                                        data: res.data.heightNum,
                                    });
                                }
                                if (res.data.unit != null) {
                                    commit("setStatus", {
                                        type: "unit",
                                        data: res.data.unit,
                                    });
                                }
                                if (res.data.marginX != null) {
                                    commit("setStatus", {
                                        type: "marginX",
                                        data: res.data.marginX,
                                    });
                                }
                                if (res.data.marginY != null) {
                                    commit("setStatus", {
                                        type: "marginY",
                                        data: res.data.marginY,
                                    });
                                }
                                if (res.data.keepScale != null) {
                                    commit("setStatus", {
                                        type: "keepScale",
                                        data: res.data.keepScale,
                                    });
                                }
                                commit("setStatus", {
                                    type: "showGrid",
                                    data: res.data.showGrid,
                                });
                                commit("setState", {
                                    type: "starter",
                                    data: res.data.starter,
                                });
                                if (res.data.content != null) {
                                    let content = JSON.parse(res.data.content);
                                    let { resolutionRatio, resolutionHeight, resolutionWidth, customFontStyle } = content;

                                    delete content.resetData;

                                    commit("setStatus", {
                                        type: "customPreferContent",
                                        data: content,
                                    });
                                    commit("setStatus", {
                                        type: "resolutionRatio",
                                        data: resolutionRatio,
                                    });
                                    commit("setStatus", {
                                        type: "resolutionHeight",
                                        data: resolutionHeight,
                                    });
                                    commit("setStatus", {
                                        type: "resolutionWidth",
                                        data: resolutionWidth,
                                    });
                                    commit("setStatus", {
                                        type: "customFontStyle",
                                        data: customFontStyle || "1",
                                    });
                                }
                                resolve(res.data);
                            } else {
                                $edApi.updateUserPrefer({
                                    id: state.userInfo.user_id,
                                    token: state.userInfo.token,
                                    obj: {
                                        content: '{"resetData": 1}',
                                    },
                                });
                                resolve();
                                console.log("获取偏好设置失败!");
                            }
                        })
                        .catch((err) => {
                            console.log("获取偏好设置失败!", err);
                            reject();
                        });
                }
            });
        },
        setUserPrefer({ state }, obj) {
            if (state.userInfo === "") return;
            let userID = state.userInfo.user_id;
            if (userID) {
                let params = { id: userID, token: state.userInfo.token, obj };
                $edApi.updateUserPrefer(params);
            }
        },
        setUserContentPrefer({ state, commit }, data) {
            commit("setStatus", {
                type: "customPreferContent",
                data: data,
            });
            let jsonStr = JSON.stringify(data);
            let params = {
                id: state.userInfo.user_id,
                token: state.userInfo.token,
                obj: { content: jsonStr },
            };
            if (state.userInfo)
                $edApi.updateUserPrefer(params).then((e) => {
                    console.log(e);
                });
        },
        // 获取帮助提示相关信息
        getUserHelp({ state, commit }) {
            if (state.userInfo === "") return;
            return new Promise((resolve, reject) => {
                let userID = state.userInfo.user_id;
                let userToken = state.userInfo.token;
                if (userID) {
                    let params = { id: userID, token: userToken };
                    $edApi
                        .getUserHelp(params)
                        .then((res) => {
                            let itemArr = res.data.data,
                                itemObj = {};
                            itemArr.forEach((item) => {
                                itemObj[item.type] = item.used;
                            });
                            commit("setStatus", {
                                type: "helpContent",
                                data: itemObj,
                                // data:{
                                //     flowchartButton: 0,
                                //     mindShape: 0,
                                //     mindTip: 0,
                                //     swimContainer: 0,
                                //     swimTip: 0, // 暂时不用
                                //     smartShape: 0, // 暂时不用
                                //     smartTip: 0,
                                //     orgFloat: 0,
                                //     timelineBlock: 0
                                // }
                            });
                            resolve();
                        })
                        .catch((err) => {
                            console.log("获取帮助提示相关信息失败!", err);
                            reject();
                        });
                }
            });
        },
        // 设置帮助提示相关信息
        setUserHelp({ state }, obj) {
            if (state.userInfo === "") return;
            let userID = state.userInfo.user_id;
            if (userID) {
                $edApi.updateUserHelp(userID, state.userInfo.token, obj);
            }
        },
        getUserLimit({ state, commit }, platform) {
            let params = { id: state.userInfo.user_id, token: state.userInfo.token, platform };
            $edApi.getUserLimit(params).then((res) => {
                commit("setState", {
                    type: "graphkd",
                    data: res.data.graph_kd,
                });
            });
        },
        getAIOpenRecord({ state, commit }) {
            let params = { user_id: state.userInfo.user_id, token: state.userInfo.token };
            $edApi.getAIOpenRecord(params).then((result) => {
                commit("setState", {
                    type: "isAIOpened",
                    data: result,
                });
            });
        },
    },
};
